<template>
  <div>
    <van-collapse
      v-model="activeNames1"
      ref="collapseParent"
      class="topCollapse"
    >
      <van-collapse-item title="打开搜索引擎" name="1">
        <van-collapse v-model="activeNames" accordion @change="collapseChange">
          <van-collapse-item title="综合检索" name="1">
            <div class="searchItem">
              <div class="name">查询内容</div>
              <div class="content">
                <van-field
                  v-model="search1"
                  clearable
                  input-align="center"
                  placeholder="请输入查询内容"
                  @input="changeSearch1"
                />
              </div>
            </div>
            <div class="searchItem">
              <div class="name">文件效力</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value1"
                    :options="option1"
                    @change="changeValue1"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="btn" @click="searchDatas(1)">
              <van-button
                block
                icon="search"
                style="border-radius: 30px"
                type="info"
                >查询</van-button
              >
            </div>
          </van-collapse-item>
          <van-collapse-item title="行业检索" name="2">
            <div class="searchItem">
              <div class="name">行业</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value2"
                    :options="option2"
                    @change="changeValue2"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="searchItem">
              <div class="name">文件效力</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value5"
                    :options="option1"
                    @change="changeSearch5"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="btn" @click="searchDatas(2)">
              <van-button
                block
                icon="search"
                style="border-radius: 30px"
                type="info"
                >查询</van-button
              >
            </div>
          </van-collapse-item>
          <van-collapse-item title="税收优惠检索" name="3">
            <van-tabs
              v-model="radio"
              color="#d1a679"
              title-inactive-color="#646566"
              @change="changeRadio"
              style="width:100%"
              line-width="70"
            >
              <van-tab title="税收优惠项目" name="1">
                <div class="searchItem">
                  <div class="name">优惠项目</div>
                  <div class="content">
                    <van-dropdown-menu>
                      <van-dropdown-item
                        v-model="value11"
                        :disabled="disabled2"
                        :options="option11"
                        @change="changeValue11"
                      />
                    </van-dropdown-menu>
                  </div>
                </div>
              </van-tab>
              <van-tab title="税收优惠行业" name="3">
                <div class="searchItem">
                  <div class="name">优惠行业</div>
                  <div class="content">
                    <van-dropdown-menu>
                      <van-dropdown-item
                        v-model="value13"
                        :disabled="disabled3"
                        :options="option13"
                        @change="changeValue13"
                      />
                    </van-dropdown-menu>
                  </div>
                </div>
              </van-tab>
              <van-tab title="税收优惠税种" name="2">
                <div class="searchItem">
                  <div class="name">优惠税种</div>
                  <div class="content">
                    <van-dropdown-menu>
                      <van-dropdown-item
                        v-model="value12"
                        :disabled="disabled1"
                        :options="option12"
                        @change="changeValue12"
                      />
                    </van-dropdown-menu>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
            <!-- <van-radio-group v-model="radio" @change="changeRadio">
              <van-cell-group>
                <van-cell title="税收优惠项目" clickable @click="radio = '1'">
                  <template #right-icon>
                    <van-radio name="1" />
                  </template>
                </van-cell>
                <van-cell title="税收优惠行业" clickable @click="radio = '3'">
                  <template #right-icon>
                    <van-radio name="3" />
                  </template>
                </van-cell>
                <van-cell title="税收优惠税种" clickable @click="radio = '2'">
                  <template #right-icon>
                    <van-radio name="2" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
            <div class="searchItem" v-show="radio == '1'">
              <div class="name">优惠项目</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value11"
                    :disabled="disabled2"
                    :options="option11"
                    @change="changeValue11"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="searchItem" v-show="radio == '3'">
              <div class="name">优惠行业</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value13"
                    :disabled="disabled3"
                    :options="option13"
                    @change="changeValue13"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="searchItem" v-show="radio == '2'">
              <div class="name">优惠税种</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value12"
                    :disabled="disabled1"
                    :options="option12"
                    @change="changeValue12"
                  />
                </van-dropdown-menu>
              </div>
            </div> -->

            <div class="searchItem" style="margin-top:10px">
              <div class="name">文件效力</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value6"
                    :options="option1"
                    @change="changeSearch6"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="btn" @click="searchDatas(3)">
              <van-button
                block
                icon="search"
                style="border-radius: 30px"
                type="info"
                >查询</van-button
              >
            </div>
          </van-collapse-item>
          <van-collapse-item title="条约检索" name="4">
            <div class="searchItem">
              <div class="name">国家/地区</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value3"
                    :options="option3"
                    @change="changeValue3"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="searchItem">
              <div class="name">文件效力</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value7"
                    :options="option1"
                    @change="changeSearch7"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="btn" @click="searchDatas(4)">
              <van-button
                block
                icon="search"
                style="border-radius: 30px"
                type="info"
                >查询</van-button
              >
            </div>
          </van-collapse-item>
          <van-collapse-item title="进出口税收检索" name="5">
            <div class="searchItem">
              <div class="name">类别</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value4"
                    :options="option4"
                    @change="changeValue4"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="searchItem">
              <div class="name">文件效力</div>
              <div class="content">
                <van-dropdown-menu>
                  <van-dropdown-item
                    v-model="value8"
                    :options="option1"
                    @change="changeSearch8"
                  />
                </van-dropdown-menu>
              </div>
            </div>
            <div class="btn" @click="searchDatas(5)">
              <van-button
                block
                icon="search"
                style="border-radius: 30px"
                type="info"
                >查询</van-button
              >
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
export default {
  props: [
    "option1",
    "option2",
    "option3",
    "option4",
    "option11",
    "option12",
    "option13",
    "disabled1",
    "disabled2",
    "disabled3",
  ],
  data() {
    return {
      activeNames: [],
      activeNames1: ["1"],
      // 文件效力
      value1: "1",
      value5: "1",
      value6: "1",
      value7: "1",
      value8: "1",

      // 综合检索
      search1: "",

      // 行业检索
      value2: "0",

      // 税收优惠检索
      radio: "1",
      value11: "0", // 优惠项目
      value12: "0", // 优惠税种
      value13: "0", // 优惠行业

      // 条约检索
      value3: "0",

      // 进出口税收检索
      value4: "0",
      lists4: [],
      queryBtn: 0,
      doubleLists: false,
      commonLists: [], // 通用规定
      industryLists: [], // 专属规定
      countries: false, // 切换专属和国家(地区)
    };
  },
  methods: {
    changeSearch1() {
      this.$emit("changeSearch1", this.search1);
    },
    changeSearch5() {
      this.$emit("changeSearch5", this.value5);
    },
    changeSearch6() {
      this.$emit("changeSearch6", this.value6);
    },
    changeSearch7() {
      this.$emit("changeSearch7", this.value7);
    },
    changeSearch8() {
      this.$emit("changeSearch8", this.value8);
    },

    changeValue1() {
      this.$emit("changeValue1", this.value1);
    },
    changeValue2() {
      this.$emit("changeValue2", this.value2);
    },
    changeValue3() {
      this.$emit("changeValue3", this.value3);
    },
    changeValue4() {
      this.$emit("changeValue4", this.value4);
    },
    changeValue11() {
      this.$emit("changeValue11", this.value11);
    },
    changeValue12() {
      this.$emit("changeValue12", this.value12);
    },
    changeValue13() {
      this.$emit("changeValue13", this.value13);
    },
    changeRadio() {
      console.log(this.radio);
      this.value11 = "0";
      this.value12 = "0";
      this.value13 = "0";
      this.value6 = "1";
      this.$emit("changeRadio", this.radio);
    },
    searchDatas(name) {
      document.querySelector(".topCollapse").style.top = 0;
      this.$refs["collapseParent"].$el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      this.activeNames1 = [];
      // this.activeNames = [];
      this.$emit("searchDatas", name);
    },
    // 切换
    collapseChange(value) {},
  },
};
</script>

<style lang="less" scoped>
.selectNavS {
  padding: 20px 20px 150px;
}
.searchItem {
  display: flex;
  .name {
    line-height: 52px;
    flex: 0 0 70px;
    text-align: center;
    color: #333;
  }
  .content {
    flex: 1;
  }
}
.btn {
  text-align: center;
  margin-top: 20px;
}
/deep/.van-tabs__wrap {
  margin-bottom: 10px;
}
/deep/.van-tabs__nav--card {
  margin: 0 0;
}
.topCollapse {
  top: -60px;
}
</style>
